
export default {
    root: {
        fontSize: '1rem'
    },
    colorScheme: {
        light: {
            root: {
                'color.one': '{yellow.500}',
                'color.two': '{lime.500}',
                'color.three': '{fuchsia.600}',
                'color.four': '{orange.500}'
            }
        },
        dark: {
            root: {
                'color.one': '{pink.400}',
                'color.two': '{sky.400}',
                'color.three': '{emerald.400}',
                'color.four': '{amber.400}'
            }
        }
    }
};
